export default "__VITE_ASSET__6543df77__"